<div class="login-box">
    <div class="container">
        <div class="row">
            <div class="col-md-6 login-left">
                <h3 i18n>Inicio sesión</h3>
                <app-input [label]="labelUser" [messageError]="loginError" [placeholder]="placeUser"
                    [(inputval)]="username"></app-input>
                <app-input [label]="labelPassword" [messageError]="passwordError" [placeholder]="placePass"
                    [(inputval)]="password"></app-input>
                <div class="actions">
                    <div class="row text-center">
                        <button type="button" class="btn btn-primary btn-rounded" i18n (click)="login()">ACCEDER</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>